import { render, staticRenderFns } from "./VersionsControl.vue?vue&type=template&id=193a2696&scoped=true"
import script from "./VersionsControl.vue?vue&type=script&lang=js"
export * from "./VersionsControl.vue?vue&type=script&lang=js"
import style0 from "./VersionsControl.vue?vue&type=style&index=0&id=193a2696&prod&scoped=true&lang=css"
import style1 from "./VersionsControl.vue?vue&type=style&index=1&id=193a2696&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193a2696",
  null
  
)

export default component.exports